import React from 'react';
import { Link } from 'react-router-dom';
import './Banner.css';

const Banner = () => {
    return (
        <section className='banner-bg'>
            <div className="container ">
                <div className="row">

                    <div className="col-md-6 text-content">
                        <h1 className='banner-title f-os'>THE BEST FITNESS STUDIO IN TOWN</h1>
                        <p className='mb-5 f-ro'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum accusamus dolorum, id rem tempore eum error voluptates repudiandae ut. Animi soluta voluptatem, minus quasi voluptas mollitia dolore porro iure adipisci.</p>
                        <Link to={'/pricing'}>
                            <button className='brand-btn f-ro'>JOIN US</button>
                        </Link>

                    </div>
                    <div className="col-md-5 offset-md-1">
                        <div className="cross-shape"></div>
                    </div>
                </div>
            </div>
            
        </section>
    );
};

export default Banner;